<template>
  	<!-- Page Content Wrapper -->
  	<div v-if="permissionsArray.includes('can_manage_users')" id="page-content-wrapper" class="admin-content-area dashboard">
    	<div class="container-fluid xyz location-listing">
      		<div class="page-header-top-container" style="position: fixed;">
        		<div class="page-name" style="width:40%">{{customer_name}} Inventory</div>
        		<button type="submit" v-on:click.prevent="backToCustomerList()" class="btn btn-primary waves-effect pull-right">Back</button>
        		<button type="submit" class="btn btn-primary waves-effect pull-right" v-on:click.prevent="AddPart()">Add Part</button>
                <template v-if="isNonVVGDealer == 'NO'">
                    <template v-if="syncButtonShow">
        		        <button type="submit" id="syncCustomerParts" class="btn btn-primary waves-effect pull-right" v-on:click.prevent="syncPart()">Sync Parts</button>
                    </template>
                </template>
                <button :disabled="disableButtons.export" type="submit" class="btn btn-primary waves-effect pull-right" v-on:click.prevent="loadInventoryParts(true)">{{buttonNames.export}}</button>
                <button :disabled="disableButtons.import" type="submit" class="btn btn-primary waves-effect pull-right" v-on:click.prevent="importInventoryParts(true)">{{buttonNames.import}}</button>
                <button type="submit" id='refreshList' title='Refresh' class="extraFeature btn btn-primary waves-effect pull-right ml-2" v-on:click.prevent="loadInventoryParts()">
                    <i class="fa fa-rotate-right" aria-hidden="true"></i>
                </button>
      		</div>
      		<!-- page content -->
      		<div class="admin-page-content" style="padding-top: 100px;">
				<div class="clearfix"></div>
				<div :class="'app-filter-good-table-container cust-inventory-margin text-align-placeholder-customer-inventory ' + countryBaseClass">
					<vue-good-table
						ref="listInventory"
						mode="remote"
						title="Inventory"
						@on-page-change="onPageChange"
						@on-column-filter="onColumnFilter"
						@on-per-page-change="onPerPageChange"
						@on-sort-change="onSortChange"
						@on-selected-rows-change="selectionChanged"
                        @on-cell-click="onCellClick"
                        :row-style-class="rowStyleClassFn"
						:totalRows="totalRecords"
						:columns="columns"
						:rows="rows"
						:selectOptions="{
							enabled: true,
							selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
							selectionInfoClass: 'custom-class',
							selectionText: 'rows selected',
							clearSelectionText: 'clear',
						}"
						:pagination-options="{
							enabled: true,
							mode: 'pages',
							pageLabel: 'Page',
							position: 'both',
							perPage: serverParams.perPage,
							setCurrentPage: serverParams.setCurrentPage,
							perPageDropdown: [25, 50, 100, 200 ,500],
							dropdownAllowAll: false,
						}"
						:search-options="{
							enabled: false,
						}">

                        <!-- Custome Pagination -->
                        <template slot="pagination-top" slot-scope="props">
                            <div class="vgt-wrap__footer top-pagination crm">
                                <div  class="row">
                                    <div class="col-sm-12 col-md-2 PerPage">
                                        <v-select title="Select Per Page"
                                            v-model="serverParams.perPage"
                                            @change="changedValueTask"
                                            @input="changedValueTaskCustomPerPageTask()"
                                            name="customPerPage"
                                            id="customPerPage"
                                            label="text"
                                            :clearable="false"
                                            :searchable="false"
                                            :filterable="false"
                                            :options="serverParams.perPageDropdown"
                                            placeholder="Select Per Page">
                                        </v-select>
                                    </div>
                                    <div class="mt-2 col-sm-12 col-md-2 RowsDisplay">
                                        <p class="pageRowCount">{{paginationDisplayRowsTask}} of {{totalRecords}}</p>
                                    </div>
                                    <div class="col-sm-12 col-md-6 Pagination">
                                        <ul class="pagination">
                                            <li class="FirstPage" title="First Page">
                                                <template v-if="Number(serverParams.page) == 1">
                                                    <a class="page-link" href="javascript:void(0)">1</a>
                                                </template>
                                                <template v-else>
                                                    <a v-on:click="onPerticularPageClickTask(1)" class="page-link" href="javascript:void(0)">1</a>
                                                </template>
                                            </li>
                                            <li class="page-item PreviousPage" title="Previous Page">
                                                <template v-if="Number(serverParams.page) == 1">
                                                    <a class="page-link" href="javascript:void(0)" tabindex="-1"><i class="fa fa-angle-left"></i></a>
                                                </template>
                                                <template v-else>
                                                    <a class="page-link" href="javascript:void(0)" tabindex="-1" v-on:click="onPerticularPageClickTask(Number(serverParams.page)-1)" ><i class="fa fa-angle-left"></i></a>
                                                </template>
                                            </li>
                                            <!--New Implementation-->
                                            <template v-if="pageNumberListTask() < displayPageTask">
                                                <template v-for="(n, index) in pageNumberListTask()">
                                                    <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
                                                        <a class="page-link" href="javascript:void(0)">
                                                            {{n}}
                                                        </a>
                                                    </li>
                                                    <li :title="'Page ' +n" v-on:click="onPerticularPageClickTask(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                        <a class="page-link" href="javascript:void(0)">
                                                            {{n}}
                                                        </a>
                                                    </li>
                                                </template>
                                            </template>
                                            <template v-else>
                                                <!--End New Implementation-->
                                                <template v-if="Number(serverParams.page) <= pageCompareTask">
                                                    <template v-for="(n, index) in displayPageTask">
                                                        <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
                                                            <a class="page-link" href="javascript:void(0)">
                                                                {{n}}
                                                            </a>
                                                        </li>
                                                        <li :title="'Page ' +n" v-on:click="onPerticularPageClickTask(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                            <a class="page-link" href="javascript:void(0)">
                                                                {{n}}
                                                            </a>
                                                        </li>
                                                    </template>
                                                </template>
                                                <template v-else-if="Number(serverParams.page) >= (pageNumberListTask() - (pageCompareTask-1))">
                                                    <template v-for="(n, index) in pageNumberListTask()">
                                                        <template v-if="n > (pageNumberListTask() - displayPageTask)">
                                                            <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
                                                                <a class="page-link" href="javascript:void(0)">
                                                                    {{n}}
                                                                </a>
                                                            </li>
                                                            <li :title="'Page ' +n" v-on:click="onPerticularPageClickTask(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                                <a class="page-link" href="javascript:void(0)">
                                                                    {{n}}
                                                                </a>
                                                            </li>
                                                        </template>
                                                    </template>
                                                </template>
                                                <template v-else>
                                                    <template v-for="(n, index) in pageNumberListTask()" v-if="(n >= (Number(serverParams.page) - (pageCompareTask -1))) && (n <= (Number(serverParams.page) + (pageCompareTask -1)))">
                                                        <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
                                                            <a class="page-link" href="javascript:void(0)">
                                                                {{n}}
                                                            </a>
                                                        </li>
                                                        <li :title="'Page ' +n" v-on:click="onPerticularPageClickTask(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                            <a class="page-link" href="javascript:void(0)">
                                                                {{n}}
                                                            </a>
                                                        </li>
                                                    </template>
                                                </template>
                                            </template>
                                            <li class="page-item NextPage" title="Next Page">
                                                <template v-if="Number(serverParams.page) == pageNumberListTask()">
                                                    <a class="page-link" href="javascript:void(0)"><i class="fa fa-angle-right"></i></a>
                                                </template>
                                                <template v-else>
                                                    <a class="page-link" href="javascript:void(0)" v-on:click="onPerticularPageClickTask(Number(serverParams.page)+1)"><i class="fa fa-angle-right"></i></a>
                                                </template>
                                            </li>
                                            <li class="LastPage" title="Last Page">
                                                <template v-if="Number(serverParams.page) == pageNumberListTask()">
                                                    <a class="page-link" href="javascript:void(0)" tabindex="-1">{{pageNumberListTask()}}</a>
                                                </template>
                                                <template v-else>
                                                    <a v-on:click="onPerticularPageClickTask(pageNumberListTask())" class="page-link" href="javascript:void(0)" tabindex="-1">{{pageNumberListTask()}}</a>
                                                </template>
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="mt-2 col-lg-1 col-md-1 col-sm-2 col-xs-6">
                                        <p class="pageJumpLabel">Page : </p>
                                    </div>
                                    <div class="mt-1 col-lg-1 col-md-1 col-sm-2 col-xs-6">
                                        <input @keyup.enter="jumpToPageInTask" v-model="jumpToPageTask" type="text" class="form-control form-control-sm" name="jumpToPageTask" id="jumpToPageTask" placeholder="Page">
                                    </div>
                                </div>
                            </div>
                        </template>
                        <!-- End Custome Pagination -->

						<!-- Custome Pagination -->
						<template slot="pagination-bottom" slot-scope="props">
							<div class="vgt-wrap__footer crm">
								<div  class="row">
									<div class="col-sm-12 col-md-2 PerPage">
										<v-select title="Select Per Page"
											v-model="serverParams.perPage"
											@change="changedValueTask"
											@input="changedValueTaskCustomPerPageTask()"
											name="customPerPage"
											id="customPerPage"
											label="text"
											:clearable="false"
											:searchable="false"
											:filterable="false"
											:options="serverParams.perPageDropdown"
											placeholder="Select Per Page">
										</v-select>
									</div>
									<div class="mt-2 col-sm-12 col-md-2 RowsDisplay">
										<p class="pageRowCount">{{paginationDisplayRowsTask}} of {{totalRecords}}</p>
									</div>
									<div class="col-sm-12 col-md-6 Pagination">
										<ul class="pagination">
											<li class="FirstPage" title="First Page">
												<template v-if="Number(serverParams.page) == 1">
													<a class="page-link" href="javascript:void(0)">1</a>
												</template>
												<template v-else>
													<a v-on:click="onPerticularPageClickTask(1)" class="page-link" href="javascript:void(0)">1</a>
												</template>
											</li>
											<li class="page-item PreviousPage" title="Previous Page">
												<template v-if="Number(serverParams.page) == 1">
													<a class="page-link" href="javascript:void(0)" tabindex="-1"><i class="fa fa-angle-left"></i></a>
												</template>
												<template v-else>
													<a class="page-link" href="javascript:void(0)" tabindex="-1" v-on:click="onPerticularPageClickTask(Number(serverParams.page)-1)" ><i class="fa fa-angle-left"></i></a>
												</template>
											</li>
											<!--New Implementation-->
											<template v-if="pageNumberListTask() < displayPageTask">
												<template v-for="(n, index) in pageNumberListTask()">
													<li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
														<a class="page-link" href="javascript:void(0)">
															{{n}}
														</a>
													</li>
													<li :title="'Page ' +n" v-on:click="onPerticularPageClickTask(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
														<a class="page-link" href="javascript:void(0)">
															{{n}}
														</a>
													</li>
												</template>
											</template>
											<template v-else>
												<!--End New Implementation-->
												<template v-if="Number(serverParams.page) <= pageCompareTask">
													<template v-for="(n, index) in displayPageTask">
														<li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
															<a class="page-link" href="javascript:void(0)">
																{{n}}
															</a>
														</li>
														<li :title="'Page ' +n" v-on:click="onPerticularPageClickTask(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
															<a class="page-link" href="javascript:void(0)">
																{{n}}
															</a>
														</li>
													</template>
												</template>
												<template v-else-if="Number(serverParams.page) >= (pageNumberListTask() - (pageCompareTask-1))">
													<template v-for="(n, index) in pageNumberListTask()">
														<template v-if="n > (pageNumberListTask() - displayPageTask)">
															<li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
																<a class="page-link" href="javascript:void(0)">
																	{{n}}
																</a>
															</li>
															<li :title="'Page ' +n" v-on:click="onPerticularPageClickTask(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
																<a class="page-link" href="javascript:void(0)">
																	{{n}}
																</a>
															</li>
														</template>
													</template>
												</template>
												<template v-else>
													<template v-for="(n, index) in pageNumberListTask()" v-if="(n >= (Number(serverParams.page) - (pageCompareTask -1))) && (n <= (Number(serverParams.page) + (pageCompareTask -1)))">
														<li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
															<a class="page-link" href="javascript:void(0)">
																{{n}}
															</a>
														</li>
														<li :title="'Page ' +n" v-on:click="onPerticularPageClickTask(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
															<a class="page-link" href="javascript:void(0)">
																{{n}}
															</a>
														</li>
													</template>
												</template>
											</template>
											<li class="page-item NextPage" title="Next Page">
												<template v-if="Number(serverParams.page) == pageNumberListTask()">
													<a class="page-link" href="javascript:void(0)"><i class="fa fa-angle-right"></i></a>
												</template>
												<template v-else>
													<a class="page-link" href="javascript:void(0)" v-on:click="onPerticularPageClickTask(Number(serverParams.page)+1)"><i class="fa fa-angle-right"></i></a>
												</template>
											</li>
											<li class="LastPage" title="Last Page">
												<template v-if="Number(serverParams.page) == pageNumberListTask()">
													<a class="page-link" href="javascript:void(0)" tabindex="-1">{{pageNumberListTask()}}</a>
												</template>
												<template v-else>
													<a v-on:click="onPerticularPageClickTask(pageNumberListTask())" class="page-link" href="javascript:void(0)" tabindex="-1">{{pageNumberListTask()}}</a>
												</template>
											</li>
										</ul>
									</div>
									<div class="mt-2 col-lg-1 col-md-1 col-sm-2 col-xs-6">
										<p class="pageJumpLabel">Page : </p>
									</div>
									<div class="mt-1 col-lg-1 col-md-1 col-sm-2 col-xs-6">
										<input @keyup.enter="jumpToPageInTask" v-model="jumpToPageTask" type="text" class="form-control form-control-sm" name="jumpToPageTask" id="jumpToPageTask" placeholder="Page">
									</div>
								</div>
							</div>
						</template>
						<!-- End Custome Pagination -->

						<template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
							<div :key="key">
								<div v-if="props.column.field == 'action'">
									<router-link class="btn edit-btn-vvg waves-effect" title="Edit Part Detail" v-bind:to="{name: 'UpdateInventoryPart',params:{inventory_id:props.row.inventory_id,id:props.row.id}}">
										<i class="fa fa-pencil" aria-hidden="true"></i>
									</router-link>
									<!-- <router-link class="btn edit-btn-vvg waves-effect" title='List inventory parts' v-bind:to="{name: 'ListInventoryParts',params:{id:props.row.id}}"><i class="fa fa-list"></i></router-link>
									<button v-on:click="deleteInventory(props.row.id)" class="btn edit-btn-vvg waves-effect fa fa-trash" title="Delete Inventory">
										<i class="fa fa-trash-o" aria-hidden="true"></i>
									</button> -->
								</div>
                                <div v-else-if="props.column.field == 'inventory_part_mapper_bin_location'">
                                    <template v-if="isEditBinLocation">
                                        <input type="text" v-model="props.row.inventory_part_mapper_bin_location" v-on:blur="addUpdateBinLocation(props.row.id, props.row.inventory_part_mapper_bin_location)"/>
                                    </template>
                                    <template v-else>
                                        {{props.formattedRow['inventory_part_mapper_bin_location']}}
                                    </template>
                                </div>
								<div v-else>
                                    <div v-if="props.column.field != 'inventory_part_mapper_bin_location'">
                                        {{props.formattedRow[props.column.field]}}
                                    </div>
                                </div>
							</div>
						</template>
						<div slot="selected-row-actions" slot-scope="computed">
							{{computed.selectedRows}}
							<button :disabled="disableButtons.generateAll" v-on:click="generateQrcode(true)" class="btn btn-success" title="Generate All">{{buttonNames.generateAll}}({{totalRecords}})</button>
							<button :disabled="disableButtons.generateOneByOne" v-on:click="generateQrcode(false)" class="btn btn-success" title="Generate Selected">{{buttonNames.generateOneByOne}}({{totalRecords > selectedRows ? selectedRows : totalRecords}})</button>
						</div>
					</vue-good-table>
				</div>
      		</div>
            <!-- Import Modal -->
            <div class="medium-modal">
                <b-modal ref="add-edit-backorder-note-modal" id="modallg" size="sg" title="Import Inventory Location From Excel" class="modal-section">
                    <form id="modalForm" enctype="multipart/form-data">
                        <div class="modal-body">
                            Select Excel File to Import Inventory Location
                            <input type="file" name="excl_file" accept=".xlsx,.xls" id="uploadInventoryFile" ref="files" v-on:change="handleFilesUpload()"/>
                            <div class="form-group">
                                <label id="errorMsg" class="error"></label><br>
                            </div>
                            <a id ="demourl" href="demoUrl" target="_blank" class="btn general-button btn-info waves-effect m-r-20">
                                Download Demo
                            </a>
                        </div>
                        <div class="modal-footer">
                            <button type="button" v-on:click="importInventory($event);" class="btn general-button btn-success waves-effect" id="invImportBtn">{{importBtn}}</button>
                        </div>
                    </form>
                </b-modal>
            </div>
      		<!-- page content -->
    	</div>
    	<app-footer></app-footer>
  	</div>
  	<div v-else>
    	<no-permission></no-permission>
  	</div>
  	<!-- Page Content Wrapper -->
</template>

<script>
    var self;
    import Vue from "vue";
    import Footer from "@/components/partials/Footer";
    import EventBus from ".././event-bus";
    import { commonMixins } from "../../mixins/commonMixins";
    import { HTTP } from "../../http-common.js";
    import VueGoodTable from "vue-good-table";
    import NoAccessPermission from '../NoAccessPermission';
    import vSelect from 'vue-select';

    Vue.use(VueGoodTable);
    export default {
        name: "ListCustomerInventory",
        components: {
            "app-footer": Footer,
            "no-permission" : NoAccessPermission,
            'v-select': vSelect,
        },
        mixins: [commonMixins],
        data() {
            return {
                syncButtonShow: false,
                buttonNames : {
                    generateAll : 'Generate All',
                    generateOneByOne : 'Generate Selected',
                    export: 'Export',
                    import: 'Import',
                },
                disableButtons : {
                    generateAll : false,
                    generateOneByOne : false,
                    export: false,
                    import: false,
                },
                roleId: 0,
                firstLoad: 0,
                columns: [
                    /*{
                        label: 'Id',
                        field: 'id',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Id", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },*/
                    /*{
                        label: 'Inventory',
                        field: 'inventory_name',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Inventory", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },*/
                    {
                        label: 'Part Number',
                        field: 'part_no',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Part Number", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Part Description',
                        field: 'part_des',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Part Description", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Max Qty',
                        field: 'inventory_max_qty',
                        filterable: true,
                        type: "number",
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Max Qty", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Qty On Hand',
                        field: 'inventory_qty',
                        filterable: true,
                        type: "number",
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Qty On Hand", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Bin Location',
                        field: 'inventory_part_mapper_bin_location',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Bin Location", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Amt Cost',
                        field: 'part_amt_cost',
                        type: "number",
                        filterable: true,
                        hidden: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Amt Cost", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Unit Cost',
                        field: 'part_unit_price',
                        type: "number",
                        filterable: true,
                        hidden: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Unit Cost", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'ExtCost',
                        field: 'part_ext_price',
                        type: "number",
                        filterable: false,
                        hidden: true,
                        sortable: false,
                        thClass: 'disable-sorting',
                    },
                    /* {
                        label: 'Threshold Qty',
                        field: 'inventory_threshold_qty',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Threshold Qty", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    }, */
                    {
                        label: 'Part Last Used',
                        field: "part_last_used_date",
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "MM/DD/YYYY", // placeholder for filter input
                            filterValue: "", // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Part Add Date',
                        field: "ipm_created_at",
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "MM/DD/YYYY", // placeholder for filter input
                            filterValue: "", // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Action',
                        field: 'action',
                        sortable: false,
                        thClass: 'disable-sorting',
                    }

                ],
                rows: [],
                totalRecords: 0,
                serverParams: {
                    columnFilters: {},
                    page: 1,
                    perPage: 'All',
                    sort: {
                        field: "id",
                        type: "asc"
                    },
                    perPageDropdown : [],
                },
                customer_id:'',
                customer_name:'',
                recordsCounts: "",
                selectedRows: 0,
                permissionsArray: ['can_manage_users'],

                displayPageTask: 7,
                jumpToPageTask: 0,
                pageCompareTask: 0,
                paginationDisplayRowsTask: '',
                inventoryId: {id: '0', name: 'Select Inventory'},
                inventoryOptions:[],
                inventoryError:'',
                isEditBinLocation: false,
                importBtn : 'Import',
                files: [],
                isNonVVGDealer: 'NO',
                countryBaseClass: '',
            };
        },
        watch: {
          inventoryId: function() {
            self.loadInventoryParts(false);
          }
        },
        beforeMount: function() {
            self = this;
            EventBus.$emit("menu-selection-changed", "listCustomer");
        },
        mounted: function() {
            // process.env.APP_COUNTRY;
            self.countryBaseClass = '';
            if(process.env.APP_COUNTRY == 'AU') {
                for(var i = 0; i < self.columns.length;i++){
                    if (self.columns[i].field == "part_amt_cost") {
                        self.$set(self.columns[i], 'hidden', false);
                    }
                    if (self.columns[i].field == "part_unit_price") {
                        self.$set(self.columns[i], 'hidden', false);
                    }
                    if (self.columns[i].field == "part_ext_price"){
                        self.$set(self.columns[i], 'hidden', false);
                    }
                }
                self.countryBaseClass = 'display-parts-price';
            }
            self.isNonVVGDealer = process.env.NON_VVG_DEALER;

            var initial = process.env.ROOT_API;
            var initial = initial.replace('/v1', '');
            $("#demourl").attr("href", initial + '/demo/CustomerDemoInventory.xlsx');

            // call discussion only particular 4 users can show the sync button in admin side customer inventory list page
            // if user logged in than remove login button and registration button
            self.syncButtonShow = false;
            var userObj = localStorage.getItem("user_obj");
            if (userObj != null) {
                var userJson = JSON.parse(userObj);
                var dayforaceId = userJson['emp_id'];
                if(process.env.APP_COUNTRY == 'AU') {
                    if (
                        dayforaceId == '9999999' || dayforaceId == '37284' || dayforaceId == '34695'
                        || dayforaceId == '34696' || dayforaceId == '36957'
                    ) {
                        self.syncButtonShow = true;
                    }
                } else {
                    if (
                        dayforaceId == '9999999' || dayforaceId == '80477' || dayforaceId == '10402'
                        || dayforaceId == '80340' || dayforaceId == '13197' || dayforaceId == '10747'
                        || dayforaceId == '14807' || dayforaceId == '9999996' || dayforaceId == '13153'
                    ) {
                        self.syncButtonShow = true;
                    }
                }
            }

            self.customer_id = self.$route.params.custId;
            self.windowWidth = $(window).width();
            $(window).resize(function () {
                self.windowWidth = $(window).width();
                /* if (self.windowWidth > 767) {
                    $('.contacttDetails').hide();
                } else {
                    $('.contacttDetails').show();
                } */
                // $('.dashboard .admin-page-content.sticky .vgt-responsive').height($(window).height() - 340);
            });
            //self.getUserRole();
            //self.getUserPermissions();
            this.jumpToPageTask = this.serverParams.page;
            this.pageCompareTask = Math.ceil(this.displayPageTask / 2);
            $("#jumpToPageTask").on('keyup', function (e) {
                if (e.keyCode === 13) {  //checks whether the pressed key is "Enter"
                    self.jumpToInputPageTask(self.jumpToPageTask)
                }
            });

            this.serverParams.perPageDropdown.push(25);
            this.serverParams.perPageDropdown.push(50);
            this.serverParams.perPageDropdown.push(100);
            this.serverParams.perPageDropdown.push(200);
            this.serverParams.perPageDropdown.push(500);
            this.serverParams.perPageDropdown.push('All');
            self.loadInventoryData();

            /* setTimeout(function(){
                var stickyTop12 = 77;
                $(window).scroll(function () {
                    var windowTop = $(window).scrollTop();
                    var el = $('.admin-page-content');
                    if (el.length > 0) {
                        if (stickyTop12 < windowTop && !el.is('.sticky') && $(el).outerHeight() > ($(window).height() - 235)) {
                            el.addClass('sticky');
                            $('.dashboard .admin-page-content.sticky .vgt-responsive').height($(window).height() - 340);
                            $('#page-content-wrapper').addClass('sticky-footer');
                        }
                        else if (stickyTop12 > windowTop && el.is('.sticky')) {
                            el.removeClass('sticky');
                            $('.dashboard .admin-page-content .vgt-responsive').removeAttr('style');
                            $('#page-content-wrapper').removeClass('sticky-footer');
                        }
                    }
                });
            },500); */
        },
        methods: {
            rowStyleClassFn: function(row) {
                if(row.is_list_background_color_change == 'yes') {
                    return 'customer-inventory-parts-color';
                }
            },
            onCellClick(params) {
                self.isEditBinLocation = true;
            },
            syncPart: function() {
                $('#syncCustomerParts').text('Syncing...');
                $('#syncCustomerParts').prop("disabled", true);
                var config = {
                    headers: {
                        Authorization:localStorage.getItem("access_token")
                    },
                    params : {
                        customer_id: self.customer_id,
                    }
                };
                HTTP.get("/sync/customer/parts", config)
                    .then(function(response) {
                        $('#syncCustomerParts').text('Sync Parts');
                        $('#syncCustomerParts').prop("disabled", false);
                        if (response.status == "200") {
                            self.loadInventoryData();
                        }
                        if(response.status == 202) {
                            self.showSAlert(response.data.message,'error',false);
                        }
                    })
                    .catch(function(err) {
                        $('#syncCustomerParts').text('Sync Parts');
                        $('#syncCustomerParts').prop("disabled", false);
                        if (err.response.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (err.response.status == 401) {
                                //clear previous data
                                localStorage.clear();
                                self.$router.push("/");
                            }
                            self.error = err.response.data.message;
                        }
                    });
            },
            addUpdateBinLocation: function(id, binLocationData) {
                self.isEditBinLocation = false;
                var binLocationInventoryArr = [];
                if (id) {
                    binLocationInventoryArr.push(id);
                } else {
                    var selectedUser = this.$refs["listInventory"].selectedRows;
                    for (var i = 0; i < selectedUser.length; i++) {
                        binLocationInventoryArr.push(this.$refs["listInventory"].selectedRows[i].id);
                    }
                }
                var config = {
                };
                var fields = {
                    inventory_id_arr: binLocationInventoryArr,
                    bin_location: binLocationData,
                };
                HTTP.post("add/update/binlocation", fields, config)
                    .then(function(response) {
                        self.loadInventoryData();
                    })
                    .catch(function(err) {
                        self.$refs['my-modal'].hide();
                        if (err.response.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (err.response.status == 401) {
                                //clear previous data
                                localStorage.clear();
                                self.$router.push("/");
                            }
                        }
                    });
            },
            jumpToPageInTask: function(e) {
                self.jumpToInputPageTask(self.jumpToPageTask);
            },
            changedValueTaskCustomPerPageTask: function() {
                self.jumpToInputPageTask(self.serverParams.page);
                self.loadInventoryParts(false);
            },
            changedValueTask: function(value) {
                /*console.log(value);*/
            },
            pageNumberListTask: function() {
                var totalRecord = self.totalRecords;
                var count = 0;
                for (var i = 0; totalRecord > 0; i++) {
                    totalRecord = totalRecord - self.serverParams.perPage;
                    count++;
                }
                return count;
            },
            jumpToInputPageTask: function(pageNumber) {
                var reg = /^\d+$/;
                if (pageNumber <= 0 || pageNumber == '') {
                    pageNumber = 1;
                } else if (pageNumber > self.pageNumberListTask()) {
                    pageNumber = self.pageNumberListTask();
                    if (pageNumber <= 0 || pageNumber == '') {
                        pageNumber = 1;
                    }
                } else if (!String(self.jumpToPageTask).match(reg)) {
                    pageNumber = 1;
                }
                self.onPerticularPageClickTask(pageNumber);
            },
            onPerticularPageClickTask: function(pageNumber) {
                self.serverParams.page = pageNumber;
                self.jumpToPageTask = pageNumber;
                self.loadInventoryParts(false);
            },
            changeStatusUser : function(userId) {
                var inventoryArr = [];
                var config = {
                    headers: {
                        Authorization:localStorage.getItem("access_token")
                    }
                };
                var fields = {
                    user_id: userId
                };
                self.$swal({
                    title: "Are you sure?",
                    text: "You want to change the status",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonText: "Yes Change it!",
                    cancelButtonText: "No, Keep it!",
                    showCloseButton: true,
                    showLoaderOnConfirm: true
                }).then(result => {
                    if (result.value) {
                        HTTP.post("/user/change-user-status", fields, config)
                            .then(function(response) {
                                self.loadInventoryParts(false);
                            })
                            .catch(function(err) {
                                if (err.response.status == 0) {
                                    self.error = "Remote server can not be reachable";
                                } else {
                                    //redirect to login page if user not authenticated
                                    if (err.response.status == 401) {
                                        //clear previous data
                                        localStorage.removeItem("user_obj");
                                        localStorage.removeItem("api_token");
                                        localStorage.removeItem("profile_image");
                                        //self.$router.push("/login");
                                        //EventBus.$emit("logged-in", true, "", "");
                                    }
                                }
                            });
                    }
                });
            },
            backToCustomerList: function() {
                self.$router.push({name:'ListCustomer'});
            },
            updateParams(newProps) {
                self.serverParams = Object.assign({}, self.serverParams, newProps);
            },
            onPageChange(params) {
                self.updateParams({ page: params.currentPage });
                self.loadInventoryParts(false);
            },
            onPerPageChange(params) {
                if (params.currentPerPage != self.serverParams.perPage) {
                    self.updateParams({ perPage: params.currentPerPage });
                    self.totalRecords = self.totalRecords;
                    self.loadInventoryParts(false);
                }
            },
            onColumnFilter(params) {
                self.updateParams(params);
                {
                    field: "id";
                    field: "name";
                    field: "location_name";
                    field: "part_last_used_date";
                }
                self.serverParams.page = 1;
                var filtersPr = JSON.parse(JSON.stringify(self.serverParams));
                var filters = filtersPr.columnFilters;

                if (
                    self.firstLoad == 1 ||
                    filters.id ||
                    filters.name ||
                    filters.location_name ||
                    filters.part_last_used_date 
                ) {
                    self.loadInventoryParts(false);
                }
            },
            selectionChanged() {
                self.selectedRows = self.$refs["listInventory"].selectedRows.length;
                /*console.log(self.selectedRows);*/
            },
            onSortChange(params) {
                self.updateParams({
                    sort: {
                        type: params[0].type,
                        field: params[0].field
                    }
                });
                self.loadInventoryParts(false);
            },
            deleteInventory: function(id) {
                var inventoryArr = [];
                var config = {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("api_token")
                    }
                };

                if (id) {
                    inventoryArr.push(id);
                } else {
                    var selectedUser = this.$refs["listInventory"].selectedRows;
                    for (var i = 0; i < selectedUser.length; i++) {
                        inventoryArr.push(this.$refs["listInventory"].selectedRows[i].id);
                    }
                }
                var fields = {
                    deleteArr: inventoryArr
                };

                self.$swal({
                    title: "Are you sure?",
                    text: "You can't revert your action",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonText: "Yes Delete it!",
                    cancelButtonText: "No, Keep it!",
                    showCloseButton: true,
                    showLoaderOnConfirm: true
                }).then(result => {
                        if (result.value) {
                            HTTP.post("delete-inventory", fields, config)
                                .then(function(response) {
                                    self.loadInventoryParts(false);
                                })
                                .catch(function(err) {
                                    if (err.response.status == 0) {
                                        self.error = "Remote server can not be reachable";
                                    } else {
                                        //redirect to login page if user not authenticated
                                        if (err.response.status == 401) {
                                            //clear previous data
                                            localStorage.clear();
                                            self.$router.push("/");
                                        }
                                    }
                                });
                            self.$swal("Deleted", "You successfully deleted record(s)", "success");
                        } else {
                            self.$swal("Cancelled", "Your file is still intact", "info");
                        }
                    });
            },
            loadInventoryData:function() {
                var config = {
                    headers: {
                        Authorization:localStorage.getItem("access_token")
                    },
                    params : {
                        customer_id: self.customer_id,
                    }
                };
                HTTP.get("customer-wise-inventory", config)
                    .then(function(response) {
                        //console.log('inventory',response);
                        if (response.status == "200") {
                            self.inventoryOptions = response.data.inventory;
                            self.customer_name = response.data.customer_name;
                            // self.inventoryId = {name: response.data.inventory[0].name, id: response.data.inventory[0].id};
                            self.inventoryId = {name: response.data.inventory.name, id: response.data.inventory.id};
                        }
                    })
                    .catch(function(err) {
                        console.log('err', err)
                        if (err.response.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (err.response.status == 401) {
                                //clear previous data
                                localStorage.clear();
                                self.$router.push("/");
                            }
                            self.error = err.response.data.message;
                        }
                    });
            },
            AddPart: function() {
                if(self.inventoryId.id > 0){
                    self.$router.push({name: 'AddUpdateInventoryPart',params:{inventory_id:self.inventoryId.id, customer_id:self.customer_id}});
                }
            },
            importInventoryParts: function() {
                self.files = [];
                self.$refs['add-edit-backorder-note-modal'].show();
            },
            handleFilesUpload: function() {
                // Get the uploaded files from the input.
                var self = this;
                let uploadedFiles = "";
                uploadedFiles = self.$refs.files.files;
                //console.log(uploadedFiles);
                // Assign the uploaded file to the files array
                // this.files.pop();
                for (var i = 0; i < uploadedFiles.length; i++) {
                    self.files = [uploadedFiles[i]];
                }
                // this.getImagePreviews();
            },
            importInventory: function() {
                if(typeof(self.files) === 'undefined' || self.files == 'null' || self.files == '') {
                    self.files = [];
                    self.showSAlert("Please upload Excel file.", 'info', false);
                } else {
                    var data = new FormData();
                    data.append('inventory_id', self.inventoryId.id);
                    for (var i = 0; i < self.files.length; i++) {
                        let file = self.files[0];
                        // console.log(file);
                        data.append('excl_file', file);
                    }
                    var config = {
                        headers: {
                            Authorization:localStorage.getItem("access_token")
                        },
                    };
                    self.importBtn = 'Importing ...';
                    $('#invImportBtn').prop("disabled", true);
                    $('#invImportClose').prop("disabled", true);
                    // self.showLoader();
                    HTTP.post('/inventory/part/import', data, config)
                        .then(response => {
                            self.importBtn = 'Import';
                            $('#invImportBtn').prop("disabled", false);
                            $('#invImportClose').prop("disabled", false);
                            if(response.data.code == 200) {
                                self.loadInventoryParts(false);
                                self.$refs['add-edit-backorder-note-modal'].hide();
                                self.showSAlert(response.data.message + '<br>' + response.data.messageSkipRecords, 'success', false);
                            } else {
                                self.showSAlert(response.data.message, 'error', false);
                            }
                        })
                        .catch(function (err) {
                            self.importBtn = 'Import';
                            $('#invImportBtn').prop("disabled", false);
                            $('#invImportClose').prop("disabled", false);
                            // self.hideLoader();
                            self.catchHandler(err, function () {});
                        });
                }
            },
            loadInventoryParts: function(isExport) {
                self.firstLoad = 1;
                var newPage = Math.ceil(self.totalRecords / self.serverParams.perPage);
                if (newPage) {
                    if (newPage < self.serverParams.page) {
                        self.serverParams.page = newPage;
                    }
                }
                if(isExport) {
                    self.buttonNames.export = 'Exporting...';
                    self.disableButtons.export = true;
                }
                var config = {
                    headers: {
                        Authorization:localStorage.getItem("access_token")
                    },
                    params : {
                        page: self.serverParams.page,
                        perPage: self.serverParams.perPage,
                        filters: self.serverParams.columnFilters,
                        messageData: self.message,
                        sort: self.serverParams.sort,
                        inventory_id : self.inventoryId.id,
                        export: isExport,
                        is_website: true
                    }
                };
                HTTP.get("list-inventory-parts", config)
                    .then(function(response) {
                        if(isExport) {
                            self.buttonNames.export = 'Export';
                            self.disableButtons.export = false;
                        }
                        //console.log('inventory',response);
                        if (response.status == "200") {
                            if(response.data.message == 'success export') {
                                self.downloadFile(response.data.content.web);
                            } else {
                                self.rows = response.data.content.row;
                                self.totalRecords = response.data.content.totalRecords;
                                self.inventoryHeader = response.data.inventory_name;
                                //self.paginationDisplayRowsTask = self.getRecords(self.serverParams.page, self.serverParams.perPage, self.totalRecords);
                                self.paginationDisplayRowsTask = self.getRecords(self.serverParams.page, self.serverParams.perPage, self.totalRecords);
                            }
                            
                        }
                    })
                    .catch(function(err) {
                        if(isExport) {
                            self.buttonNames.export = 'Export';
                            self.disableButtons.export = false;
                        }
                        console.log('err', err)
                        if (err.response.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (err.response.status == 401) {
                                //clear previous data
                                localStorage.clear();
                                self.$router.push("/");
                            }
                            self.error = err.response.data.message;
                        }
                    });
            },
            generateQrcode: function(isSelectAll) {
                self.showLoader();
              	var custId = self.customer_id;
              	var jsonData = {};
              	jsonData['customerId'] = custId;
              	localStorage.setItem("customerId", custId);
              	var use = [];
              
				if(!isSelectAll) {
                    self.disableButtons.generateOneByOne = true;
					var data = this.$refs['listInventory'].selectedRows;
					for (var i = 0; i < data.length; i++) {
						use.push(this.$refs['listInventory'].selectedRows[i].id)
					}
					localStorage.setItem("generate_data", use);
					jsonData['generate_data'] = use;
				} else {
                    self.disableButtons.generateAll = true;
					jsonData['generate_data'] = "isSelectAll";
					localStorage.setItem("generate_data", "isSelectAll");
				}

				var fields = {
					is_select_all: isSelectAll,
					idArr: use,
					isGrid: false,
					customerId: self.customer_id
				};

				var config = {
					headers: {Authorization:localStorage.getItem("access_token")},
				};
				HTTP.post("generate-qrcode", fields, config)
					.then(function(response) {
                        self.hideLoader();
                        self.disableButtons.generateAll = false;
                        self.disableButtons.generateOneByOne = false;
						if (response.data.code == '200') {
                            // self.loadInventoryParts(false);
                            /* var getCurrentTimeUTC = self.getUTCDateTime();
                            localStorage.setItem("utc_date_time", getCurrentTimeUTC);
                            jsonData['utc_date_time'] = getCurrentTimeUTC;
                            localStorage.setItem("qr_code_josn_obj", JSON.stringify(jsonData));
                            // localStorage.setItem("utc_date_time", "2020-05-01 09:00:07");
                            window.open("/qrcode/print"); */
                            window.open(response.data.content);
						}
					})
					.catch(function(err) {
                        self.hideLoader();
                        self.disableButtons.generateAll = false;
                        self.disableButtons.generateOneByOne = false;
						if (err.response.status == 0) {
						    self.error = "Remote server can not be reachable";
						} else {
                            //redirect to login page if user not authenticated
                            if (err.response.status == 401) {
                                //clear previous data
                                localStorage.clear();
                                self.$router.push("/");
                            }
						}
					});
            },
        }
    };
</script>
<style scoped>
  .cust-inventory-margin {
    	margin-top: 20px;
  }
</style>


// WEBPACK FOOTER //
// src/components/Inventory/ListCustomerInventory.vue